
const commonFunctionObject = {};

const scrollToTop = () => {
  window && window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
}
commonFunctionObject.scrollToTop = scrollToTop


function addZeroInDate(value) {
  if (value < 10) {
    return '0' + value;
  } else {
    return value;
  }
}


function convertDateToDDMMMYYYY(date) {
  var month_names = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];

  var day = addZeroInDate(date.getDate());
  var month_index = date.getMonth();
  var year = date.getFullYear();

  return "" + day + "-" + month_names[month_index] + "-" + year;
}

commonFunctionObject.convertDateToDDMMMYYYY = convertDateToDDMMMYYYY



const replaceHyphenDate = (oldDate) => {
  let newDate = String(oldDate).replaceAll("-", "/")
  return newDate;
}

commonFunctionObject.replaceHyphenDate = replaceHyphenDate;


function appendZeros(accountNumber) {
  var dataAccNo = '';
  var accLength = accountNumber.length;
  if (accLength < 17) {
    var zeroLen = 17 - accLength;
    var preString = '';
    for (var i = 0; i < zeroLen; i++) {
      preString += '0';
    }
    dataAccNo = preString + '' + accountNumber;
    console.log(preString + '' + accountNumber);
  } else {
    dataAccNo = accountNumber;
  }
  return dataAccNo;
}
commonFunctionObject.appendZeros = appendZeros;


function convertDDMMYYYY(date) {
  var month = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1);
  var currentDate = ((date.getDate()) < 10) ? ('0' + (date.getDate())) : (date.getDate());
  return currentDate + '/' + month + '/' + date.getFullYear();
}
commonFunctionObject.convertDDMMYYYY = convertDDMMYYYY;

let _setCookie = (cname, cvalue, expiry) => {
  // var expires = isNum(expiry) ?  "expires="+ (new Date(Date.now()+expiry)).toUTCString() : "";
  document.cookie = cname + "=" + cvalue + ";path=/";
  console.log("Cookie : ", document.cookie);
}

commonFunctionObject._setCookie = _setCookie;

function convertYYYYMMDD(date) {
  
    const monthMap = {
      "jan": "01", "feb": "02", "mar": "03", "apr": "04", 
      "may": "05", "jun": "06", "jul": "07", "aug": "08", 
      "sep": "09", "oct": "10", "nov": "11", "dec": "12"
  };

  const parts = date?.split("-");
  const day = parts[0];
  const monthAbbr = parts[1].toLowerCase();
  const year = parts[2];

 const month = monthMap[monthAbbr];

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;

}

commonFunctionObject.convertYYYYMMDD = convertYYYYMMDD

export default commonFunctionObject

